exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".o-SearchBox {\n  background-color: #f4f4f4;\n  height: 100%;\n  border-radius: 5px; }\n  .o-SearchBox .m-FormControlWithFloatingLabel__formControl {\n    border: none;\n    outline: none; }\n\n.o-Searchbox__header {\n  background-color: #fff; }\n", ""]);

// exports
